import { HTTP, HTTPLink } from "../../../http-common";
import { IPVoiceService } from "../../../models/IPVoiceService";
import { ipOrder } from "../../../models/ipOrder";
//import { SoftPhoneDetails } from "../../../models/SoftPhoneDetails";

import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";

const state = {
  iporder: new ipOrder(),
  rows: [],
  handsets: [],
  ratePlans: [],
  message: new httpError(),
};

//getters

const getters = {
  getField,
  rows: (state) => {
    return state.rows;
  },
};

//Mutations
const mutations = {
  updateRow(state, rows) {
    state.rows = rows;
  },
  restart(state) {
    state.iporder = new ipOrder();
    state.rows = [];
    state.message = new httpError();
  },
  setRatePlan(state, ratePlan) {
    if (ratePlan !== null) state.ratePlans = ratePlan;
  },
  addRow(state, months) {
    if (state.rows.length > 0)
      state.rows.push(
        new IPVoiceService({
          contractLengthMonths: months,
          ratePlanID: state.rows[0].ratePlanID,
          extensionNo: 500 + state.rows.length,
        })
      );
    else
      state.rows.push(
        new IPVoiceService({
          contractLengthMonths: months,
        })
      );
  },
  setOrder(state, order) {
    state.iporder = order;
  },
  deleteRow(state) {
    // To enable multi-row form handling
    // we make it possible to add new rows.
    state.rows.pop();
  },
  deleteIPOrder(state) {
    state.ipOrder = {};
  },
  setProgress(state, message) {
    state.message = message;
  },
  setNewData(state, Data) {
    // To enable multi-row form handling
    // we make it possible to add new rows.
    state.rows.length = 0;
    Data.forEach(function(service) {
      state.rows.push(new IPVoiceService(service));
    });
  },
  removeRow(state, index) {
    state.rows.splice(index, 1);
  },
  setHandset(state, handsets) {
    if (handsets !== null) state.handsets = handsets;
  },
  setCallHandling(state, call) {
    state.iporder.callHandling = call;
  },

  updateField,
};

//ACTIONS
const actions = {
  updateServiceTable({ commit, dispatch }, row) {
    commit("updateRow", row);
  },
  getServices({ commit }, accountNumber) {
    return new Promise((resolve, reject) => {
      HTTP.get("vodia/GetCustomerServices/" + accountNumber)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  },
  resetIPVoice({ commit }) {
    commit("setNewData", []);
  },
  async saveIPOrder({ commit, dispatch, rootState, state }) {
    try {
      var order = await HTTP.post(
        "order/AddIPOrder/" + rootState.orders.rows[0].orderID,
        state.iporder
      );
      commit("setOrder", order.data);
      commit("orders/setIPOrder", order.data.ipOrderID, {
        root: true,
      });
      dispatch(
        "setMessage",
        new httpError({
          message: "saved OK",
          httpStatus: 200,
        })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "unable to save:" + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async getIPVoice({ commit, dispatch, rootState }) {
    try {
      var order = await HTTP.get(
        "order/GetIPOrder/" + rootState.orders.rows[0].orderID
      );
      if (order.data == null || order.data.length == 0) {
        order.data = new ipOrder();
      }
      //sanjay
      if (rootState.orders.dealer.dealer.ubDealerID == 2073)
        order.data.existingRentalCustomer = true;
      commit("setOrder", order.data);
      dispatch(
        "setMessage",
        new httpError({
          message: "Retrieved OK",
          httpStatus: 200,
        })
      );
      return Promise.resolve(order);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "Error getting order:" + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async getIPExtensions({ commit, dispatch, rootState, rootGetters }) {
    try {
      var order = await HTTP.get(
        "order/GetIPExtensions/" + rootState.orders.rows[0].orderID
      );
      commit("setNewData", []);
      if (order.data.length > 0) {
        commit("setNewData", order.data);
      } else {
        commit("addRow", rootGetters["orders/isQantas"] ? 36 : 24);
      }
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "Error getting order:" + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },

  async addIPVoice({ state, commit, dispatch, rootState }) {
    try {
      var order = await HTTP.post(
        "order/AddIPOrder/" + rootState.orders.rows[0].orderID,
        state.iporder
      );
      state.rows.forEach(
        (x) => (x.dealerSupplied = state.iporder.dealerSupplied)
      );

      var ipOrder = await HTTP.post(
        "order/AddIPExtensionsToOrder/" + rootState.orders.rows[0].orderID,
        state.rows
      );
      commit("setNewData", ipOrder.data);
      dispatch(
        "setMessage",
        new httpError({
          message: "Saved OK",
          httpStatus: 200,
        })
      );
      return Promise.resolve(ipOrder.data);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "Error Saving: " + err.message,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },

  removeRow({ state, commit, dispatch, rootState }, index) {
    return new Promise((resolve, reject) => {
      HTTP.delete(
        "order/DeleteIPExtsFromOrder/" + rootState.orders.rows[0].orderID,
        {
          data: [state.rows[index]],
        }
      )
        .then(() => {
          commit("removeRow", index);
          resolve();
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error getting order:" + err.message,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },

  async getLinkExtensions({ commit, dispatch }) {
    try {
      var ext = await HTTPLink.get("getExtensions");

      return Promise.resolve(ext.data);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "Error getting order:" + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },

  async removeRows({ state, commit, rootState }, newVal) {
    //rowCount is the number of rows to finish with
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1]);
      commit("deleteRow");
    }
    try {
      var ipexts = await HTTP.delete(
        "order/DeleteIPExtsFromOrder/" + rootState.orders.rows[0].orderID,
        {
          data: rows,
        }
      );
      return Promise.resolve(ipexts);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getRatePlans({ commit }) {
    return new Promise((resolve, reject) => {
      let filter = ["VoIP", "DID"];
      var response = HTTP.post("Order/getRatePlans/", JSON.stringify(filter));
      response
        .then(function(data) {
          var resultData = data.data;
          commit("setRatePlan", resultData);
          resolve(resultData);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async getHandsets({ commit, dispatch }) {
    try {
      var data = await HTTP.get("Order/getHandsets/", "");
      if (data) {
        var resultData = data.data;
        commit("setHandset", resultData);

        var rateplans = await dispatch("getRatePlans");
        return Promise.resolve(resultData);
      }
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "Error:" + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  setMessage({ commit, dispatch }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },
  removeIPFromOrder({ commit, dispatch }, props) {
    return new Promise((resolve, reject) => {
      let { ipOrderID, orderID } = props;

      if (ipOrderID == 0 || orderID == 0) {
        reject("Nothing passed to delete method");
        return;
      }
      HTTP.delete(`Order/RemoveIPOrderFromOrder/${orderID}/${ipOrderID}`)
        .then(() => {
          commit("restart");
          commit("orders/setIPOrder", 0, {
            root: true,
          });
          commit("addRow", 24);
          dispatch(
            "setMessage",
            new httpError({
              message: "Removed OK",
              httpStatus: 200,
            })
          );
          resolve(true);
        })
        .catch(() => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error Removing IP Order",
              httpStatus: 500,
            })
          );
          reject(false);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
